/*
 * Product-page WhatsApp enquiry.
 *
 * Two jobs:
 *   1. Keep the message in step with the selected variant. Liquid prints a
 *      correct href on first paint, so the link works with JavaScript off; this
 *      only rewrites it when the shopper changes their selection.
 *   2. Hand over between the embedded button and the floating bubble, so the
 *      page never shows two WhatsApp controls at the same time.
 *
 * The variant is read from the product form's own `[name="id"]` input, which is
 * what actually gets posted to the cart. That works whichever picker the theme
 * or an options app renders, instead of depending on one picker's events.
 */
(function () {
  'use strict';

  if (window.__ltsWhatsAppReady) return;
  window.__ltsWhatsAppReady = true;

  var root, floatBtn, links, variants = [], base = {};

  function encode(s) { return encodeURIComponent(s); }

  /* The message, rebuilt for whichever variant is currently selected. A
     single-variant product carries the placeholder title "Default Title", which
     would read as noise, so it is left out. */
  function message(variantTitle) {
    var m = base.intro + ' ' + base.title;
    if (variantTitle && variantTitle !== 'Default Title') m += ' – ' + variantTitle;
    m += '. Product link: ' + base.url + '. Could you please provide more information?';
    return m;
  }

  function currentVariantTitle() {
    /* The input the cart form posts. Prefer a form that actually has an add
       button, so a hidden or secondary form cannot win. */
    var input = document.querySelector('form[action*="/cart/add"] [name="id"]') ||
                document.querySelector('[name="id"]');
    if (!input || !input.value) return null;
    var id = String(input.value).trim();
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === id) return variants[i].title;
    }
    return null;
  }

  function sync() {
    var href = 'https://wa.me/' + base.number + '?text=' + encode(message(currentVariantTitle()));
    for (var i = 0; i < links.length; i++) links[i].href = href;
  }

  /* Lift the bubble above a sticky add-to-cart bar rather than sitting on top
     of it. Measured live, because that bar appears and disappears on scroll. */
  function liftAboveStickyBar() {
    if (!floatBtn) return;
    var bars = document.querySelectorAll(
      '.product-sticky, .sticky-atc, [class*="sticky-add"], [class*="stickyCart"], [class*="sticky-product"]'
    );
    var clear = 0;
    for (var i = 0; i < bars.length; i++) {
      var el = bars[i];
      var r = el.getBoundingClientRect();
      var cs = getComputedStyle(el);
      if (cs.position !== 'fixed' || cs.visibility === 'hidden' || !r.height) continue;
      /* Only bars actually pinned to the bottom of the window. */
      if (r.bottom > window.innerHeight - 4 && r.top < window.innerHeight) {
        clear = Math.max(clear, Math.round(window.innerHeight - r.top));
      }
    }
    document.documentElement.style.setProperty('--lts-wa-bottom', (clear ? clear + 16 : 24) + 'px');
  }

  function watchHandover() {
    if (!floatBtn) return;
    var embedded = root.querySelector('[data-lts-wa-link]');
    if (!embedded) return;

    var show = function (on) {
      if (on) {
        floatBtn.hidden = false;
        liftAboveStickyBar();
        requestAnimationFrame(function () { floatBtn.classList.add('is-in'); });
      } else {
        floatBtn.classList.remove('is-in');
        var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduced) floatBtn.hidden = true;
        else setTimeout(function () { if (!floatBtn.classList.contains('is-in')) floatBtn.hidden = true; }, 240);
      }
    };

    if (!('IntersectionObserver' in window)) { show(true); return; }

    new IntersectionObserver(function (entries) {
      /* Visible embedded button -> no bubble. Out of view -> bubble. */
      show(!entries[0].isIntersecting);
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0 }).observe(embedded);

    window.addEventListener('scroll', liftAboveStickyBar, { passive: true });
    window.addEventListener('resize', liftAboveStickyBar, { passive: true });
  }

  function init() {
    root = document.querySelector('[data-lts-wa]');
    if (!root) return;

    base = {
      number: root.getAttribute('data-number'),
      title: root.getAttribute('data-product-title'),
      url: root.getAttribute('data-product-url'),
      intro: root.getAttribute('data-intro')
    };

    var json = root.querySelector('[data-lts-wa-variants]');
    try { variants = json ? JSON.parse(json.textContent) : []; } catch (e) { variants = []; }

    floatBtn = document.querySelector('[data-lts-wa-float]');
    links = document.querySelectorAll('[data-lts-wa-link]');

    sync();
    watchHandover();

    /* Any picker ultimately writes the variant id into the form input, so watch
       that one node instead of guessing at each picker's event name. */
    var input = document.querySelector('form[action*="/cart/add"] [name="id"]') ||
                document.querySelector('[name="id"]');
    if (input && window.MutationObserver) {
      new MutationObserver(sync).observe(input, { attributes: true, attributeFilter: ['value'] });
    }
    /* Pickers that set .value in script fire no attribute mutation, so also
       listen to the events the theme and the options app do emit. */
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('form[action*="/cart/add"]')) sync();
    });
    ['variant:change', 'variantChange', 'on:variant:change', 'product:variant-change'].forEach(function (name) {
      document.addEventListener(name, sync);
    });
    /* Ella swaps the URL's ?variant= as the selection changes. */
    window.addEventListener('popstate', sync);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
